import React from 'react';
import Header from '../../../../components/header';
import CommentItem from '../../../../module/shop/comment/commentItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import UseGetComments from '../hooks/useGetComments';
import {postOwnerType} from '../../../../models/post/postOwnerType';
import DotsLoading from '../../../../components/dotsLoading';

const Comments = () => {
  const {data, fetchNextPage, isLoading} = UseGetComments(
    postOwnerType.SUPPLIER,
  );
  return (
    <>
      <Header title="نظرات" />
      <InfiniteScroll
        dataLength={data?.pages.flatMap(x => x.results).length || 0} //This is important field to render the next data
        next={() => {
          fetchNextPage();
        }}
        style={{overflow: 'inherit'}}
        className="overflow-inherit"
        hasMore={!!data?.pages[data?.pages.length - 1].next}
        loader={
          <div className="my-3">
            <DotsLoading />
          </div>
        }
        scrollableTarget="scrollableDiv"
      >
        {isLoading ? (
          <DotsLoading />
        ) : (
          data &&
          React.Children.toArray(
            data?.pages.flatMap(item =>
              item?.results?.map(x => <CommentItem comment={x} />),
            ),
          )
        )}
      </InfiniteScroll>
    </>
  );
};

export default Comments;
